import $ from 'jquery';
import { Loader } from "@googlemaps/js-api-loader"

const MapsLoader = new Loader({
  apiKey: "AIzaSyCrBqgyB57ojQqiqfiZ8fuVHw_wYutXxE4",
  version: "weekly",
})


class AddressMap {
  constructor(element, options) {
    this._element  = element
    this._options = options

    MapsLoader.load().then(async () => {
      const { Geocoder } = await google.maps.importLibrary('geocoding')
      const { Map } = await google.maps.importLibrary('maps')
      const { Marker } = await google.maps.importLibrary('marker')

      this._geocoder = new Geocoder()
      this._map = new Map(this._element, {
        fullscreenControl: false,
        mapTypeId: google.maps.MapTypeId.HYBRID,
        streetViewControl: false,
        zoom: 20,
      })
      this._marker = new Marker({
        map: this._map,
        draggable: true,
      })

      this.setAddress(this._options.address)

      this._marker.addListener('dragend', e => this._triggerLocation(e.latLng))
    })

  }

  setAddress(address) {
    this._geocoder.geocode({ 'address': address }, (results, status) => {
      if (status == 'OK' && results.length >= 1) {
        this.setPosition(results[0].geometry.location)
      } else {
        alert('No pudimos encontrar tu dirección. Por favor, intentá con tu ubicación actual o comunicate con nosotros.');
      }
    })
  }

  setPosition(location) {
    const latLng = new google.maps.LatLng(location)
    this._map.setCenter(latLng)
    this._marker.setPosition(latLng)
    this._triggerLocation(latLng)
  }

  _triggerLocation(latLng) {
    $(this._element).trigger($.Event('location.addressMap', { latLng: latLng }))
  }

  static _jQueryInterface(method, options) {
    return this.each(async function () {
      let data = $(this).data('_addressMap')
      let _options = typeof method === 'object' ? method : null

      if (! data) {
        data = await new AddressMap(this, _options)
        $(this).data( '_addressMap', data )
      }

      if (typeof method === 'string') {
        if (typeof data[method] === 'undefined') {
          throw new TypeError(`No method named "${method}"`)
        }
        data[method](options)
      }
    })
  }

}

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn.addressMap             = AddressMap._jQueryInterface
$.fn.addressMap.Constructor = AddressMap

export default AddressMap;